import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import RedirectLink from './../models/RedirectLink';

const initialState = {
    isFetching: false,
    isFetched: false,
    redirectLinks: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        redirectLink: new RedirectLink()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.REDIRECT_LINK_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.REDIRECT_LINK_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                redirectLinks: action.redirectLinks.result,
                pageSize: action.redirectLinks.pageSize,
                pageIndex: action.redirectLinks.pageIndex,
                totalCount: action.redirectLinks.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.REDIRECT_LINK_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, redirectLinks: [] };
        case Types.REDIRECT_LINK_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.REDIRECT_LINK_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    redirectLink: action.redirectLink
                }
            };
        case Types.REDIRECT_LINK_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.REDIRECT_LINK_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.REDIRECT_LINK_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.REDIRECT_LINK_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.REDIRECT_LINK_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default: 
            return state
    }
}
